import React, { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import cx from 'classnames';
import { IDeviceCategory, IDevice } from '@/api/device';
import UploadCommonModal from '../UploadCommonModal';
import { MAX_RELATED_DEVICES } from '@/constants';
import Image from 'next/image';
import Styles from './index.module.scss';

const emptyImage = require('@/assets/icon/hardware-empty-icon.png');

export interface IDeviceModal {
  selections?: IDevice[];
  deviceCategories?: IDeviceCategory[];
  onCancel: () => void;
  onChange: (devices: IDevice[]) => void;
}
const DeviceModalPc = ({
  deviceCategories=[],
  selections=[],
  onCancel,
  onChange,
}: IDeviceModal) => {
  const [selectedDevices, setSelectedDevices] = useState(selections);
  const [selectedCategory, setSelectedCategory] = useState(deviceCategories[0] || {});
  const [selectedSeries, setSelectedSeries] = useState<string | null>(deviceCategories[0]?.series?.length === 0 ? deviceCategories[1].series[0].name:deviceCategories[0].series[0].name);

  const [isExceed, setIsExceed] = useState(false);
  const t = useTranslations();
  const handleChangeCategory = (category: IDeviceCategory) => {
    setSelectedCategory(category);
    setSelectedSeries(category?.series[0]?.name);
  };

  const isDeviceExist = (deviceKey: string) => selectedDevices.filter(({ key }) => key === deviceKey).length > 0;

  const handleSelectDevice = (item: IDevice) => {
    const isExist = isDeviceExist(item.key);
    if (!isExist && selectedDevices.length >= MAX_RELATED_DEVICES) {
      setIsExceed(true);
      return;
    }
    if(!isExist) {
      setSelectedDevices([...selectedDevices, item]);
    }
  };

  const handleChangeSeries = (seriesName:string) => {
    setSelectedSeries(seriesName);
  }

  // useEffect(()=>{
  //   const seriesLiElem = document.querySelector(".series") as HTMLElement;
  //   const devicesWrapper = document.querySelectorAll<HTMLElement>(".deviceWrapper");
  //   if(seriesLiElem && devicesWrapper) {
  //     const w = seriesLiElem?.offsetWidth;
  //     devicesWrapper.forEach((deviceWrapper)=>{
  //       deviceWrapper.style.left = w + 'px';
  //     })
  //   }
  // })

  const onAddDevices = () => {
    if(selectedDevices.length > 0) {
      onChange(selectedDevices);
    }
  }

  const onRemove = (key: string) => {
    const devices = selectedDevices.filter((selectedDevice)=>selectedDevice.key!==key);
    setSelectedDevices(selectedDevices.filter((selectedDevice)=>selectedDevice.key!==key));
    setIsExceed(devices.length >= MAX_RELATED_DEVICES);
  }

  const renderEmptyDevice = () => {
    return (selectedCategory?.name === deviceCategories[0]?.name) && (deviceCategories[0]?.series?.length === 0) && (
      <div className={Styles.deviceEmpty}>
        <Image
          src={emptyImage}
          alt="empty-device"
          width={98}
          height={98}
          loader={({ src }) => src}
        />
        <p className={Styles.emptyText}>{t("empty_device")}</p>
      </div>
    )
  };

  return (
    <UploadCommonModal
      onCancel={onCancel}
      title={t("thread_add_device")}
      contentClassName={Styles.content}
    >
      <div className={Styles.main}>
        <div className={Styles.tab}>
          <ul className={Styles.deviceCategory}>
            {
              deviceCategories.map((deviceCate)=>{
                return <li className={cx(Styles.deviceCate, {[Styles.active]: selectedCategory.name === deviceCate.name})} key={deviceCate.name} onClick={()=>handleChangeCategory(deviceCate)}>{deviceCate.name}</li>
              })
            }
          </ul>
          <ul className={Styles.seriesWrapper}>
            {
              selectedCategory?.series?.map(({ id, name, devices })=>(
                <div key={name} className={Styles.seriesAll} id="series">
                  <li className={cx('series', Styles.series, {[Styles.active]: selectedSeries === name})} onClick={()=>handleChangeSeries(name)}>{ name }</li>
                  <ul className={cx('deviceWrapper', Styles.deviceWrapper, {[Styles.deviceWrapperActive]: selectedSeries === name})}>
                    {
                      devices.map(({ key, name, device })=>{
                        return <li key={key} className={cx(Styles.device, {[Styles.active]: isDeviceExist(key)})} onClick={() => handleSelectDevice({ key, name, device })}>{name}</li>
                      })
                    }
                  </ul>
                </div>
              ))
            }
            {/* 我的设备为空 */}
            {
              renderEmptyDevice()
            }
          </ul>
        </div>
        <div className={Styles.selected}>
          <ul>
            {
              selectedDevices.map(({key, name})=>(
                <li key={key}>{ name }<i className={Styles.deleteIcon} onClick={()=>onRemove(key)}></i></li>
              ))}
          </ul>
        </div>
        {
          isExceed && <div className={Styles.error}>{t('error_device_maximum', { maximum: MAX_RELATED_DEVICES })}</div>
        }
        <div className={cx(Styles.addBtn, {[Styles.addBtnActive]: selectedDevices.length > 0})} onClick={onAddDevices}>{t("thread_add_device")}</div>
      </div>
    </UploadCommonModal>
  );
}

export default DeviceModalPc;
